import { ReactNode } from 'react';

import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

interface WarningAlertProps {
  title: string;
  subtitle?: string;
  severity?: 'error' | 'warning' | 'info' | 'success';
  icon?: ReactNode;
  sx?: object;
}

export function WarningAlert({
  title,
  subtitle,
  severity = 'warning',
  icon,
  sx = {},
}: WarningAlertProps) {
  return (
    <Alert severity={severity} icon={icon} sx={{ width: '100%', py: 0, ...sx }}>
      <Typography
        component="span"
        variant="subtitle2"
        sx={{ fontWeight: 600, color: 'warning.dark', display: 'block' }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          component="span"
          variant="caption"
          sx={{
            color: 'text.secondary',
            display: 'block',
            fontSize: '0.80em',
            mt: 0.5,
            whiteSpace: 'pre-line',
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Alert>
  );
}
